import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";

function Grid({ desktopCols, mobCols, tabletCols, children }) {
  const gridTemplateColumnsDesktop = "1fr ".repeat(desktopCols);
  const gridTemplateColumnsMobile = "1fr ".repeat(mobCols);
  const gridTemplateColumnsTablet = tabletCols
    ? "1fr ".repeat(tabletCols)
    : "1fr ".repeat(mobCols);

  return (
    <Box
      display="grid"
      gridTemplateColumns={[
        gridTemplateColumnsMobile,
        gridTemplateColumnsTablet,
        gridTemplateColumnsDesktop,
        null,
      ]}
      gridColumnGap={[20, null, "2.38vw", null]}
      gridRowGap={[23, null, "2.38vw", null]}
    >
      {children}
    </Box>
  );
}

export default Grid;

Grid.propTypes = {
  desktopCols: PropTypes.number.isRequired,
  mobCols: PropTypes.number.isRequired,
  tabletCols: PropTypes.number,
};
